import { render, staticRenderFns } from "./Bonus.vue?vue&type=template&id=262a8250&scoped=true&"
import script from "./Bonus.vue?vue&type=script&lang=ts&"
export * from "./Bonus.vue?vue&type=script&lang=ts&"
import style0 from "./Bonus.vue?vue&type=style&index=0&id=262a8250&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262a8250",
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QImg});
